import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddMentorshipProgramMutationVariables = Types.Exact<{
  object: Types.MentorshipProgram_Insert_Input;
}>;


export type AddMentorshipProgramMutation = { __typename?: 'mutation_root', insert_mentorshipProgram_one?: { __typename?: 'mentorshipProgram', id: number, name: string, createdAt?: any | null, workspaceId: number, workspaceLocationId?: number | null, mentorshipProgramModules: Array<{ __typename?: 'mentorshipProgramModule', id: number, name: string, mentorshipProgramProgresses: Array<{ __typename?: 'mentorshipProgramProgress', id: number, completed: boolean }> }>, mentorshipSurveys: Array<{ __typename?: 'mentorshipSurvey', id: number, preSurveyEnabled: boolean, preSurveyLink?: string | null, preSurveyMentorRequired?: boolean | null, preSurveyMenteeRequired?: boolean | null, midSurveyEnabled: boolean, midSurveyLink?: string | null, midSurveyMentorRequired?: boolean | null, midSurveyMenteeRequired?: boolean | null, postSurveyEnabled: boolean, postSurveyLink?: string | null, postSurveyMentorRequired?: boolean | null, postSurveyMenteeRequired?: boolean | null }> } | null };


export const AddMentorshipProgramDocument = gql`
    mutation addMentorshipProgram($object: mentorshipProgram_insert_input!) {
  insert_mentorshipProgram_one(object: $object) {
    id
    name
    createdAt
    workspaceId
    workspaceLocationId
    mentorshipProgramModules {
      id
      name
      mentorshipProgramProgresses {
        id
        completed
      }
    }
    mentorshipSurveys {
      id
      preSurveyEnabled
      preSurveyLink
      preSurveyMentorRequired
      preSurveyMenteeRequired
      midSurveyEnabled
      midSurveyLink
      midSurveyMentorRequired
      midSurveyMenteeRequired
      postSurveyEnabled
      postSurveyLink
      postSurveyMentorRequired
      postSurveyMenteeRequired
    }
  }
}
    `;
export type AddMentorshipProgramMutationFn = Apollo.MutationFunction<AddMentorshipProgramMutation, AddMentorshipProgramMutationVariables>;

/**
 * __useAddMentorshipProgramMutation__
 *
 * To run a mutation, you first call `useAddMentorshipProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMentorshipProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMentorshipProgramMutation, { data, loading, error }] = useAddMentorshipProgramMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAddMentorshipProgramMutation(baseOptions?: Apollo.MutationHookOptions<AddMentorshipProgramMutation, AddMentorshipProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMentorshipProgramMutation, AddMentorshipProgramMutationVariables>(AddMentorshipProgramDocument, options);
      }
export type AddMentorshipProgramMutationHookResult = ReturnType<typeof useAddMentorshipProgramMutation>;
export type AddMentorshipProgramMutationResult = Apollo.MutationResult<AddMentorshipProgramMutation>;
export type AddMentorshipProgramMutationOptions = Apollo.BaseMutationOptions<AddMentorshipProgramMutation, AddMentorshipProgramMutationVariables>;